module.exports = __webpack_public_path__ + "static/media/solar-cells.e9c03f3e.svg";